import isFunction from '../../utils/is-function';

export default class Logger {
  constructor(options) {
    if (!options) {
      throw Error('Cannot create logger. Options is not defined');
    }

    if (!isFunction(options.formatFn)) {
      throw TypeError('formatFn is not a function');
    }

    this.options = options;

    this.log('Logger is initialized');
    this.disable();
  }

  disable() {
    this.disabled = true;
  }

  enable() {
    this.disabled = false;
  }

  isEnabled() {
    return !this.disabled;
  }

  log(message, payload = {}) {
    if (this.isEnabled()) {
      // eslint-disable-next-line no-console
      console.info(this.options.formatFn(message), payload);
    }
  }

  error(message, payload = {}) {
    if (this.isEnabled()) {
      // eslint-disable-next-line no-console
      console.error(this.options.formatFn(message), payload);
    }
  }
}
